import { render } from "./SplitTreatments.vue?vue&type=template&id=cd4a5214"
import script from "./SplitTreatments.vue?vue&type=script&lang=js"
export * from "./SplitTreatments.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__